// api-model.ts
import camelcaseKeys from 'camelcase-keys';
import { SnakeCasedPropertiesDeep } from './snake-case-deep.type';

// Generic base class that knows how to hydrate from snake_cased API JSON
type Ctor<T, J> = new (json: J) => T;

export class ApiModel<TShape> {
  constructor(json: SnakeCasedPropertiesDeep<TShape>) {
    Object.assign(this as unknown as TShape, camelcaseKeys(json, { deep: false }));
  }

  // Works for subclasses without re-declaring
  static fromApi<TShape, TInstance>(
    this: Ctor<TInstance, SnakeCasedPropertiesDeep<TShape>>,
    json: SnakeCasedPropertiesDeep<TShape>
  ): TInstance {
    return new this(json);
  }
}

export type ApiResponseOf<T> = SnakeCasedPropertiesDeep<T>;
